import React, {Component} from "react";
import PropTypes from 'prop-types';
import {Table, Button, Card, Col, Row } from "reactstrap";
import {globals} from "../Globals/Globals"
import {SyncDelete} from 'datasync-core'
import {DsSource} from "datasync-source"

class EventsRawTableDataSync2 extends Component{
    constructor(props){
        super(props);
        }
    
    componentDidMount = async () => {
    }

    eventRendering = () => {
        if (!this.props.table)
            return(<h1><b>Too many props</b> set at same time. please choose between : <ul><li>table</li><li>grid</li><li>carousel</li><li>carousel2</li></ul></h1>)

        if (this.props.table) return this.tableRendering()
    }    

    onEditEventClickHandler = async (p_int_index_in_array) => {        
        //Trigger Edit on parent view
        if (this.props.onEditEventHandler)
                this.props.onEditEventHandler(this.props.event_list[p_int_index_in_array])
        else{
            console.log(`onEditEventClickHandler : props.onEditEventHandler unset p_int_index_in_array=${p_int_index_in_array}`)
        }
    }

    onOpenEventClickHandler = async (p_int_index_in_array) => {        
        //Trigger Open viewer parent view
        if (this.props.onOpenEventHandler)
                this.props.onOpenEventHandler(this.props.event_list[p_int_index_in_array])
        else {
            console.log(`onOpenEventHandler : props.onOpenEventHandler unset p_int_index_in_array=${p_int_index_in_array}`)
        }
    }

    on_failed_handler = () => {
        alert("Save failed !")
    }             

    /**
     * Prototype : onDeleteEventClickHandler
     * @param {*} eventItemId 
     */
    onDeleteEventClickHandler = async (eventItemId) => {
        try{
            if (globals.parameters.debugging){
                console.clear();
                console.log("15:onDeleteEventClickHandler");
                console.log("eventItemId =>",eventItemId)
                console.log("this.props.event_list[depositItemId] =>",this.props.event_list[eventItemId])                    
            }

            if (window.confirm("Voulez-vous supprimer cet Événement"))
            SyncDelete({
                datasync_url:globals.datasync_service.url,
                data_guid: this.props.event_list[eventItemId].data_guid, 
                on_delete_result_callback:(p_s_data_guid, p_bool_success, p_s_error_message) => {
                    console.log(`onDeleteEventClickHandler(p_s_data_guid=${p_s_data_guid}, p_bool_success=${p_bool_success?"true":"false"}, p_s_error_message=${p_s_error_message})`)
                    if (p_bool_success){
                        //Success
                        alert("Événement supprimé")

                        //brodcast state list
                        if (this.props.onTerminate) {
                            this.props.onTerminate(this.props.carousel,this.props.event_list.filter((item, j) => j !== eventItemId))
                        } else {alert("EventsRawTableDataSync::onTerminate is not defined !")}
                    }
                    else{
                        //Deletion failed
                        alert(`Erreur de suppression d'Événement ! err:${p_s_error_message}`)
                    }
              }
                });
          }
          catch(e){
            alert(e.message)
          }
    }

    tableRendering = () => {
        let table_body = null;
        console.log("15:tableRendering")
        if (!((this.props.event_list != null) && (this.props.event_list.length > 0))){
            table_body = <tr><td colSpan="4">Aucun événement</td></tr>;
        }
        else{
            table_body = this.props.event_list.map((eventItem,i)=>{
                let event_title = eventItem.data_blob.data_tier.event_title
                let event_date = eventItem.data_blob.data_tier.event_date
                let event_time = eventItem.data_blob.data_tier.event_time
                console.log(`tableRendering[${i}] -> ${eventItem}`)
                return  <tr key={i} className="thumbnail">
                        {!this.props.read_only &&
                        <td className="col_logo"><Button onClick={()=>{this.onDeleteEventClickHandler(parseInt(i,10))}} style={{cursor:"pointer"}}>Effacer</Button></td>}
                        <td className="col_logo">
                            <p>{event_title}</p>
                        </td>
                        <td className="col_logo">
                            <p>{event_date}</p>
                        </td>
                        <td className="col_logo">
                            <p>{event_time}</p>
                        </td>
                    </tr>});
                }

        return(
            <Table striped responsive={true}>
                <tbody>
                    {table_body}
                </tbody>
            </Table>
            );
    }

    render(){
        return (
            <>
                {(this.props.event_list==null) && <DsSource
                    one_block_pull = {false}
                    session_guid = {this.props.current_session}
                    datasync_url = {globals.datasync_service.url}
                    company_guid = {globals.datasync.jlrpt_company_guid} 
                    table_guid= {globals.datasync.event_table_guid}
                    seek_filter_clause = {this.props.user_filter}
                    
                    onAvailableItemsCount = {(available_items)=>{
                        if (this.props.debugging) console.log(`15:DataSyncSource::Available event:${available_items} with filter clause "${this.props.user_filter}"`)
                        //Trigger onFetchHandler
                        if (this.props.onFetchItems)
                            this.props.onFetchItems(available_items)
                    }}

                    onDataIsReady = {
                        (event_blob_list)=>{
                            if (this.props.debugging) console.log("15:on_event_ready_callback::event_blob_list=>", event_blob_list); 
                            if (this.props.debugging) console.log("15:onRenderTableCallback called")
                            if (this.props.onTerminate) {this.props.onTerminate((this.props.carousel || this.props.carousel2),event_blob_list)} else {alert("EventsRawTableDataSync2::onTerminate not defined")}}
                    }

                    onDataError = {
                        (error_message)=>{
                            alert(error_message)
                            //Trigger onFetchHandler
                            if (this.props.onFetchItems)
                                this.props.onFetchItems(0)
                        }
                    }
                    />}
                {this.eventRendering()}
            </>);
    }
}


EventsRawTableDataSync2.propTypes = { 
    table: PropTypes.bool,
};

EventsRawTableDataSync2.defaultProps = {
    table:true,
};


export default EventsRawTableDataSync2;
